import { Table } from '@tanstack/react-table';
import { exhaustiveCheck } from '../../../../../../utils/exhaustive-check';
import { DATE_COLUMN_ID, IS_PAID_CONFIDENCE_SCORE_COLUMN_ID } from '../review-matches-table-columns-definition';
import { SortingVariant } from '../table-sorting-content';

export const onSortingOptionSelect = <TData>(table: Table<TData>) => {
  return (sorting: SortingVariant) => {
    switch (sorting) {
      case 'CONFIDENCE_SCORE_LOW_TO_HIGH':
        table.setSorting([{ id: IS_PAID_CONFIDENCE_SCORE_COLUMN_ID, desc: false }]);
        return;
      case 'CONFIDENCE_SCORE_HIGH_TO_LOW':
        table.setSorting([{ id: IS_PAID_CONFIDENCE_SCORE_COLUMN_ID, desc: true }]);
        return;
      case 'DATE_OLD_TO_NEW':
        table.setSorting([{ id: DATE_COLUMN_ID, desc: false }]);
        return;
      case 'DATE_NEW_TO_OLD':
        table.setSorting([{ id: DATE_COLUMN_ID, desc: true }]);
        return;
      default:
        return exhaustiveCheck(sorting);
    }
  };
};
